import { apiRequest } from "./api";

export interface CreateTaskPayload {
  matterId: number;
  title: string;
  assignedUserIds: number[];
  status?: string;
}

export async function createTask(payload: CreateTaskPayload): Promise<unknown> {
  return apiRequest("/task/task", {
    method: "POST",
    body: {
      matterId: payload.matterId,
      title: payload.title,
      assignedUserIds: payload.assignedUserIds,
      status: payload.status ?? "To-do",
    },
  });
}
